import Cloud from "../pages/Cloud";
import Dashboard from "../pages/Dashboard";
import Favorite from "../pages/Favorite";
import Recent from "../pages/Recent";

import { ReactComponent as CloudIcon } from "../assets/svg/cloud.svg";
import { ReactComponent as DashboardIcon } from "../assets/svg/dashboard.svg";
import { ReactComponent as FavoriteIcon } from "../assets/svg/favorite.svg";
import { ReactComponent as RecentIcon } from "../assets/svg/recent.svg";
import SubFolder from "../pages/Cloud/SubFolder";
import SubFile from "../pages/Cloud/SubFile";
import { DeleteOutlined } from "@ant-design/icons";
import Trash from "../pages/Trash";
import { ReactComponent as DashboardLabelIcon } from "../assets/svg/dashboardLabelIcon.svg";
import { ReactComponent as DeleteListItems } from "../assets/svg/trashBinLabelIcon.svg";

export const routesArray = [
  {
    icon: <DashboardLabelIcon />,
    name: "dashboard", // <-- i18n key
    path: "/",
    element: <Dashboard />,
  },
  // {
  //   icon: <CloudIcon />,
  //   name: "myCloud", // <-- i18n key
  //   path: "/cloud",
  //   element: <Cloud />,
  // },
  {
    icon: <DeleteListItems />,
    name: "trash", // <-- i18n key
    path: "/trash",
    element: <Trash />,
  },
];

export const subPages = [
  {
    name: "Images",
    path: "/cloud/images",
    element: <SubFolder />,
  },
  {
    name: "Videos",
    path: "/cloud/videos",
    element: <SubFolder />,
  },
  {
    name: "Docs",
    path: "/cloud/docs",
    element: <SubFolder />,
  },
  {
    name: "Contacts",
    path: "/cloud/contacts",
    element: <SubFolder />,
  },
  {
    name: "Audios",
    path: "/cloud/audios",
    element: <SubFolder />,
  },
  {
    name: "Files",
    path: "/cloud/files",
    element: <SubFile />,
  },
];
